import { TOGGLE_SELECTED } from '../constants'

export default (indices: number[], sameValue = false): { type: string; indices: number[]; sameValue: boolean } => ({
    type: TOGGLE_SELECTED,
    indices,
    sameValue
})
